import register_dom_update from "../navigation/register_dom_update"
import state from "../state/main"

function make_tracking_function(name) {
  return (_e, event) => {
    if (!event.detail.initial) {
      // @ts-expect-error TS2339
      state.track_event(name)
    }
  }
}

register_dom_update({
  login: make_tracking_function("login"),
  logout: make_tracking_function("logout"),
  signup: make_tracking_function("sign_up"),
})
